import React, { useState, useEffect } from 'react';
import { Fetch } from '../utils/Utils.js';
import SuccessMessage from '../shared/SuccessMessage.js';
import ErrorMessage from '../shared/ErrorMessage.js';
import { useTranslation } from 'react-i18next';

export const DefaultBullSettings = () => {
  const { t } = useTranslation();
  const [bulls, setBulls] = useState([]);
  const [settings, setSettings] = useState(null);
  const [selectedBullId, setSelectedBullId] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch bulls and current settings on mount
  useEffect(() => {
    const fetchData = async () => {
      // Fetch bulls
      Fetch("/api/data/reproduction.bulls", "GET", null,
        (data) => {
          setBulls(data || []);
        },
        () => {
          console.error('Error fetching bulls');
        }
      );

      // Fetch current settings
      Fetch("/api/data/account.settings", "GET", null,
        (data) => {
          if (data && data.length > 0) {
            setSettings(data[0]);
            setSelectedBullId(data[0].default_bull_id || "");
          }
          setLoading(false);
        },
        () => {
          console.error('Error fetching settings');
          setLoading(false);
        }
      );
    };

    fetchData();
  }, []);

  const handleBullChange = (e) => {
    const newBullId = e.target.value;
    const selectedBull = bulls.find(b => b._id === newBullId);

    setSuccess("");
    setError("");

    const body = {
      default_bull_id: newBullId,
      default_bull_name: selectedBull ? selectedBull.name : ""
    };

    // If settings exist, use PATCH, otherwise POST
    const method = settings && settings._id ? "PATCH" : "POST";

    if (method === "PATCH" && settings._id) {
      body._id = settings._id;
    }

    Fetch("/api/data/account.settings", method, JSON.stringify(body),
      () => {
        setSelectedBullId(newBullId);
        setSuccess(t("settings_saved"));

        // Update settings state if we just created it
        if (method === "POST") {
          Fetch("/api/data/account.settings", "GET", null,
            (data) => {
              if (data && data.length > 0) {
                setSettings(data[0]);
              }
            },
            () => {}
          );
        }
      },
      () => {
        setError(t("settings_save_error"));
      }
    );
  };

  if (loading) {
    return <div>{t("loading")}...</div>;
  }

  return (
    <div className="DataCollectionAdd">
      <h3>{t("default_bull_settings")}</h3>
      <p className="settings-hint">{t("default_bull_hint")}</p>
      <select
        name="default_bull"
        value={selectedBullId}
        onChange={handleBullChange}
      >
        <option value="" disabled hidden>-- {t("select_bull")} --</option>
        {bulls.map((bull) => (
          <option key={bull._id} value={bull._id}>
            {bull.name}
          </option>
        ))}
      </select>
      <SuccessMessage message={success} />
      <ErrorMessage message={error} />
    </div>
  );
};

export default DefaultBullSettings;
